import React from 'react';
import { Bookmarks } from './Bookmarks';

export default function Home(props) {


  return (
    <div className="container">
      <div className='card mt-2 p-3'>

        {/*<h2>Welcome!!!</h2>*/}
        {/*<i className="fas fa-user fa-2x"></i>
        <i className="far fa-user fa-2x"></i> */}
              <img src="welcome.jpg" alt="welcome" ></img>




          <Bookmarks />


      </div>


    </div>
  );

}